import React from 'react';
import "./index.css";

const Home = () => {
  return (
    <>
      <section className='home-sec' id='home'>
        <div className='sec-1'>
          <h4>Hi, my name is</h4>
        </div>
        <div className='sec-2'>
          <h1>Prince Patel</h1>
        </div>
        <div className='sec-3'>
          <h2>I build things for web.</h2>
        </div>
        <div className='sec-4'>
          <p>I'm a Software Engineer, a Backend Node js developer. <br/>
            Currently I am focussing on MERN full stack development.
          </p>
        </div>
      </section>
    </>
  )
}

export default Home